import { useFirestore, useFirestoreCollectionData } from 'reactfire';
 
import {
  collection,
  CollectionReference,
  orderBy,
  query,
  where
} from 'firebase/firestore';

import { User } from '../firebase/entities';

type WithId<T> = T & { id: string };
 
const useFetchUserById = (
  id: string
) => {
  const firestore = useFirestore();
  const userCollection = 'users';
  const followersCollection = 'followers';
  const experiencesCollection = 'experiences';
  
  const userHook = useFirestoreCollectionData(query(
    collection(firestore, userCollection) as CollectionReference<WithId<User>>,
    where('id', '==', id),
  ), {
    idField: 'id'
  });
  
  const followersHook = useFirestoreCollectionData(query(
    collection(firestore, followersCollection) as any,
    where('followerId', '==', id),
  ), {
    idField: 'id'
  });
  
  const followingHook = useFirestoreCollectionData(query(
    collection(firestore, followersCollection) as any,
    where('userId', '==', id),
  ), {
    idField: 'id'
  });
  
  const experiencesHook = useFirestoreCollectionData(query(
    collection(firestore, experiencesCollection) as any,
    where('userId', '==', id),
    orderBy('createdAt', 'desc')
  ), {
    idField: 'id'
  });

  return {
    userHook,
    followersHook,
    followingHook,
    experiencesHook
  };
}
 
export default useFetchUserById;